function hideCartDrawerTitleIfEmpty() {
  const cartItemsContainer = document.querySelector('.gr-cart__items');
  const cartDrawerTitle = document.querySelector('.gr-cart-draw__title');
  
  if (!cartDrawerTitle) {
    return;
  }

  if (!cartItemsContainer) {
    cartDrawerTitle.style.display = 'none';
  } else {
    cartDrawerTitle.style.display = 'block';
  }
}

const observer = new MutationObserver(function(mutationsList) {
  mutationsList.forEach(function(mutation) {
    if (mutation.type === 'childList' || mutation.type === 'attributes') {
      hideCartDrawerTitleIfEmpty();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(hideCartDrawerTitleIfEmpty, 500);
});

document.addEventListener('click', function (event) {
  if (event.target.matches('.gr-cart-item__remove') || event.target.closest('.gr-cart-item__remove')) {
    setTimeout(hideCartDrawerTitleIfEmpty, 500);
  }
});

const targetNode = document.body;

observer.observe(targetNode, { childList: true, subtree: true, attributes: true });
